const routeName = {
    LOGIN: 'login',
    SMS_LOG: 'smsLog',
    AGREE_PERSONAL_INFORMATION_RECORD_LOG: 'agreePersonalInformationRecordLog',
    EMAIL_SEND_RECORD_LOG: 'emailSendRecordLog',
    NOTIFY_LOG: 'notifyLog',
    REDIRECT_PAGE: 'redirectPage',
    // 手機e方便、保戶會員專區 SSO 登入轉導頁
    // TODO: /mobileLogin 以及 /scvLogin 之後會統合成 /ssoLogin
    SSO_SCV: 'scvLogin',
    SSO_MOBILE: 'mobileLogin',
    SSO_PAGE: 'ssoLogin',
    LOGOUT: 'logout',

    // 首頁
    HOME: 'home',
    // 紀錄
    RECORD: 'record',
    // 變更項目列表
    SERVICE: 'service',
    // 新增變更項目列表
    ADD_SERVICE: 'addService',
    // 投資型保單列表
    POLICY_INVESTMENT: 'policyInvestment',
    // 傳統型保單列表
    POLICY_BASIC: 'policyBasic',
    // 640 確認聯絡資料
    CONFIRM_TEL_MAIL: 'confirmTelMail',
    // 631 確認聯絡資料
    CONTACT_INFO: 'contactInfo',
    // 非640確認聯絡資料
    EDIT_TEL_MAIL: 'editTelMail',

    // 沒有權限
    NO_AUTH: 'noAuth',
    // 找不到頁面
    NOTFOUND: 'notFound',
    FORBIDDEN: 'forbidden',
    ANNOUNCEMENT: 'announcement',
    ERRORMESSAGE: 'errorMessage',

    // 高收益債券基金風險預告書
    RISK_NOTICE: 'riskNotice',
    // 退補費
    REFUND_PAYMENT: 'refundPayment',
    OTP: 'otp',
    // 變更完成頁面
    FINISH: 'finish',
    // 變更資料確認頁
    CONFIRM_DATA: 'confirmData',

    /** BC 地址電話email by 單 */
    PROPOSER_INFO: 'proposerInfo',
    NOTIFY_COMPANIES: 'notifyCompanies',

    /** BD 地址電話email by 人 */
    PROPOSER_INFO_BY_USER: 'proposerInfoByPerson',
    NOTIFY_COMPANIES_BY_USER: 'notifyCompaniesByPerson',

    /** B1 繳別變更 */
    PAYMENT_PERIOD_TERMS: 'paymentPeriodTerms',
    PAYMENT_PERIOD: 'paymentPeriod',

    /** B4 電子通知單服務 */
    ENOTIFY_DESCRIPTION: 'enotifyDescription',
    ENOTIFY: 'enotify',

    /** B5 要保人指定匯款帳戶 */
    PH_BANK_ACC: 'phBankAcc',

    /** B6 受益人指定匯款帳戶 */
    BENE_FI_BANK_ACC: 'beneFiBankAcc',

    /** B7 被保險人指定匯款帳戶 */
    INSURED_BANK_ACC: 'insuredBankAcc',

    /** BA 指定聯絡人作業 */
    ASSIGN_CONTACT: 'assignContact',
    ASSIGN_CONTACT_DESCRIPTION: 'assignContactDescription',

    /** AE 減少保單帳戶價值準備金 */
    WITHDRAW_POLICY_TERMS: 'withdrawPolicyTerms',
    WITHDRAW_POLICY: 'withdrawPolicy',

    /** AF 指定扣取每月費用之順序 */
    VU07: 'vu07',

    /** AG 投資配息/提解給付方式變更 */
    INVEST_DIVIDEND_PAY_WAY: 'investDividendPayWay',

    /** A1 目標/計畫/每期保費暨配置比例/繳別變更 */
    PREMIUM_TERMS: 'premiumTerms',
    PREMIUM: 'premium',

    /** A2 目標/計畫/每期保費暨配置比例/繳別變更 */
    DELAY_PAYMENT: 'delayPayment',

    /** A4 定期定額投資金額 */
    VALUE_AVERAGING_TERMS: 'valueAveragingTerms',
    VALUE_AVERAGING: 'valueAveraging',

    /** A5 單筆增額/不定期投資金額申請 */
    ONE_TIME_INVEST_TERMS: 'oneTimeInvestTerms',
    ONE_TIME_INVEST: 'oneTimeInvest',
    ONE_TIME_INVEST_SURVEY: 'oneTimeInvestSurvey',

    /** A6 投資標的轉換 */
    TRANSFORM_EXPORT: 'transformExport',
    TRANSFORM_TERMS: 'transformTerms',
    TRANSFORM_IMPORT: 'transformImport',

    /** A7 部份投資終止 */
    TERMINATE_TERMS: 'terminateTerms',
    TERMINATE: 'terminate',

    /** A9 新台幣貨幣帳戶定期定額投資金額轉換 */
    NTD_AVERAGING_TERMS: 'ntdAveragingTerms',
    NTD_AVERAGING: 'ntdAveraging',

    /** IQ 投資屬性問卷 */
    QUESTIONNAIRE: 'questionnaire',
    RESULT: 'result',
    REDIRECT_IQ: 'redirectIQ',
    REDIRECTING_IQ: 'redirectingIQ',

    /** 借款 */
    LOAN_TERM_ONE: 'loanTermOne',
    LOAN_TERM_TWO: 'loanTermTwo',
    LOAN_SELECT_ACCOUNT: 'loanSelectAccount',
    LOAN_PROGRAM: 'loanProgram',
    LOAN_PROGRAM_DOCUMENTS: 'loanProgramDocuments',

    /** 申請金融機構轉帳電子化授權 */
    AUTH_METHODS: 'authMethods',
    AUTH_POLICY: 'authPolicy',
    AUTH_TERMS: 'authTerms',
    AUTH_ACCOUNT: 'authAccount',
    AUTH_READING: 'authReading',

    /** 信用卡效期延長 */
    CREDITCARD_POLICY: 'creditCardPolicy',
    CREDITCARD_EXPIRY_DATE: 'creditCardExpiryDate',

    /** 申請信用卡授權 */
    CREDIT_CARD_AUTH_TERMS: 'creditCardAuthTerm',
    CREDIT_CARD_AUTH_CARD_INFO: 'creditCardAuthInfo',
    CREDIT_CARD_AUTH_POLICY: 'creditCardAuthPolicy',

    /** 自行繳費 */
    PAY_OWN_TERMS: 'payOwnTerms',
    PAY_OWN_POLICY: 'payOwnPolicy',

    /** 自動墊繳意願變更 */
    AUTO_PREMIUM_MODIFICATION_TERMS: 'autoPremiumModificationTerms',
    AUTO_PREMIUM_MODIFICATION: 'autoPremiumModification',

    /** 清償自動墊繳本息 */
    PAY_OFF_INTEREST_TERMS: 'payOffInterestTerms',
    PAY_OFF_INTEREST: 'payOffInterest',

    /** 電子通知單服務(多張) */
    MULTI_ENOTIFY_TERMS: 'multiEnotifyTerms',
    MULTI_ENOTIFY: 'multiEnotify',

    /** B3_保險單補發 */
    POLICY_APPLY: 'policyApply',
    /** D1_自行繳費申請 */
    PAY_CHANGE: 'payChange',
    /** C1_保單繳清 */
    POLICY_PAID_UP: 'policyPaidUp',
    /** AB_ISAB減少年金保單價值準備金 */
    VALUE_RESERVE_ISAB: 'valueReserveISAB',
    /** C4_自動墊繳意願變更 */
    AUTO_PREM_LOAN: 'autoPremLoan',
    /** B2_紅利/增值回饋分享金給付方式變更 */
    DIVIDEND_CHANGE: 'dividendChange',
    /** AD_保單帳戶價值通知方式變更 */
    POLICY_VAL_NOTIFY: 'policyValNotify',
    /** AC_年金給付方式變更 */
    ANNUITY_CHANGE: 'annuityChange',
    REDIRECT_ACCOUNT: 'account',

    /** LINEPNP */
    LINEPNP: 'linepnp',


    CLOUD_E_COUNTER_HOME: 'cloudECounterHome',

    CLOUD_E_COUNTER_RECORD_APPLICANT_CHANGE: 'cloudECounterRecordApplicantChange',
    CLOUD_E_COUNTER_RECORD_LOAN: 'cloudECounterRecordLoan',
    CLOUD_E_COUNTER_RECORD_NAME: 'cloudECounterRecordName',
    CLOUD_E_COUNTER_RECORD_BENEFICIARY: 'cloudECounterRecordBeneficiary',
    CLOUD_E_COUNTER_RESERVE_RESERVE: 'cloudECounterReserveReserve',
    CLOUD_E_COUNTER_RESERVE_HOME: 'cloudECounterReserveHome',
    CLOUD_E_COUNTER_RESERVE_NOTICE: 'cloudECounterReserveNotice',
    CLOUD_E_COUNTER_RESERVE_RECORD: 'cloudECounterReserveRecord',
    CLOUD_E_COUNTER_RESERVE_RECORD_APPLICANT_CHANGE: 'cloudECounterReserveRecordApplicantChange',
    CLOUD_E_COUNTER_RESERVE_RECORD_LOAN: 'cloudECounterReserveRecordLoan',
    CLOUD_E_COUNTER_RESERVE_RECORD_NAME: 'cloudECounterReserveRecordName',
    CLOUD_E_COUNTER_RESERVE_RECORD_BENEFICIARY: 'cloudECounterReserveRecordv',
    CLOUD_E_COUNTER_RESERVE_VIDEO: 'cloudECounterReserveVideo',
    CLOUD_E_COUNTER_RESERVE_IDENTITY_RECOGNITION: 'cloudECounterReserveIdentityRecognition',

    CLOUD_E_COUNTER_POLICY: 'cloudECounterPolicy',
    CLOUD_E_COUNTER_CONFIRM: 'cloudECounterConfirm',
    CLOUD_E_COUNTER_PERIOD: 'cloudECounterPeriod',
    CLOUD_E_COUNTER_APPLY_OTP: 'cloudECounterApplyOtp',
    CLOUD_E_COUNTER_APPLY_FINISH: 'cloudECounterApplyFinish',
    CLOUD_E_COUNTER_PHONE: 'cloudECounterPhone',

    CLOUD_E_COUNTER_APPLICANT_CHANGE_INFO: 'cloudECounterApplicantChangeInfo',
    CLOUD_E_COUNTER_APPLICANT_INSURED_NAME_CHANGE_INFO: 'cloudECounterApplicantInsuredNameChangeInfo',
    CLOUD_E_COUNTER_APPLICANT_INSURED_NAME_CHANGE_CONFIRM: 'cloudECounterApplicantInsuredNameChangeConfirm',

    CLOUD_E_BENEFICIARY_HOME: 'cloudEBeneficiaryHome',
    CLOUD_E_BENEFICIARY_POLICY: 'cloudEBeneficiaryPolicy',
    CLOUD_E_BENEFICIARY_INFO: 'cloudEBeneficiaryInfo',
    CLOUD_E_BENEFICIARY_CHECK: 'cloudEBeneficiaryCheck',

    CLOUD_COUNTER_HOME: 'cloudCounterHome',

    CLOUD_E_COUNTER_LOAN_NOTICE: 'cloudECounterLoanNotice',
    CLOUD_E_COUNTER_LOAN_SELECT_POLICY: 'cloudECounterLoanSelectPolicy',
    CLOUD_E_COUNTER_LOAN_CHECK: 'cloudECounterLoanCheck',
    CLOUD_E_COUNTER_LOAN_CONTACT_INFO_CHECK: 'cloudECounterLoanContactInfoCheck',
    CLOUD_E_COUNTER_LOAN_RESERVE_PHONE: 'cloudECounterLoanReservePhone',
    CLOUD_E_COUNTER_LOAN_FINISH: 'cloudECounterLoanFinish',
    CLOUD_E_COUNTER_LOAN_SELECT_SPECIFIC: 'cloudECounterLoanSelectSpecific',
    CLOUD_E_COUNTER_LOAN_SPECIFIC: 'cloudECounterLoanSpecific',
};
export default Object.freeze(routeName);
